import React from 'react';
import {CarouselProvider, Dot, Slide, Slider} from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';
import Thumbnail from "./Thumbnail";
import BioSlide from "./BioSlide";

export default function TeamCarousel(props) {
    const {teamMembers} = props;

    const thumbnails = teamMembers.map((teamMember, index) => (
        <div className="col-3 grow p-2" key={teamMember.name}>
            <Dot
                className="btn thumbnail-btn h-100 w-100 p-0"
                disabled={false}
                onClick={(event) => {
                    document.getElementById('slider-container').scrollIntoView(
                        {block: 'nearest', behavior: 'smooth'}
                    );
                }}
                slide={index}
            >
                <Thumbnail
                    image_source={teamMember.image_source}
                    name={teamMember.name}
                    job_title={teamMember.job_title}
                />
            </Dot>
        </div>
    ));

    const slides = teamMembers.map((teamMember, index) => (
        <Slide
            className="team-slide"
            index={index}
            key={teamMember.name}>
            <BioSlide
                teamMember={teamMember}
            />
        </Slide>
    ));

    return (
        <CarouselProvider
            className='team-carousel'
            dragEnabled={false}
            infinite={true}
            isIntrinsicHeight={true}
            naturalSlideWidth={1}
            naturalSlideHeight={1}
            totalSlides={teamMembers.length}
        >
            <div className="no-gutters justify-content-center row">
                {thumbnails}
            </div>
            <div className="px-2 py-4" id="slider-container">
                <Slider>
                    {slides}
                </Slider>
            </div>
        </CarouselProvider>
    );
}

    import { render } from 'react-dom'                                    
    if (window.reactComponents === undefined) {                           
      window.reactComponents = {}                                         
    }                                                                     
    window.reactComponents.undefined = (function() {                   
    let _args = {}                                                        
                                                                          
    return {                                                              
      init: function (Args) {                                             
        _args = Args                                                      
      },                                                                  
      render: function () {                                               
        const  { id, ...props } = JSON.parse(_args)                       
        render(<undefined {...props}/>, document.getElementById(id))   
      }                                                                   
    }                                                                     
  }())